import React from 'react';
import NextReviewDateField from '../List/field/NextReviewDateField';
import {
  READ_CAREER_DEVELOPMENT_NEXT_REVIEW_DATE,
  UPDATE_CAREER_DEVELOPMENT_NEXT_REVIEW_DATE,
} from 'domain/shared/employee';
import { useAuthorization } from 'framework/authorization';
import { useFormShowContext, DateInput } from 'framework/form';
import { Box } from '@mui/material';
import EditFormShowButton from 'domain/people/employee/shared/button/showEdit/EditFormShowButton';
import FormActionButtons from 'domain/people/employee/shared/button/showEdit/FormActionButtons';

const CareerReviewContent = () => {
  const { isEditMode } = useFormShowContext();
  const { isGranted } = useAuthorization();
  const canReadNextReviewDate = isGranted(READ_CAREER_DEVELOPMENT_NEXT_REVIEW_DATE);

  return (
    <>
      <Box>
        <Box sx={{ position: 'absolute', right: '-15px', top: 0 }}>
          {isEditMode ? null : <EditFormShowButton requiredPermission={UPDATE_CAREER_DEVELOPMENT_NEXT_REVIEW_DATE} />}
        </Box>

        {isEditMode ? (
          <Box display="flex" flexDirection="column">
            <DateInput source="nextReviewDate" label="Next review date" />
            <FormActionButtons sxWrapper={{ justifyContent: 'flex-end', ml: 0 }} />
          </Box>
        ) : (
          <NextReviewDateField label="Next review date:" source="nextReviewDate" isVisible={canReadNextReviewDate} />
        )}
      </Box>
    </>
  );
};

export default CareerReviewContent;
